import { apiClient } from './client';

export const openAriApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        openAri: builder.mutation<void, { bookId: string; resourceId: string; manifest: string; jumpOffPoint?: string | null; analyticsUrl?: string | null }>({
            query: ({ bookId, resourceId, manifest, jumpOffPoint, analyticsUrl }) => ({
                url: '/api/openAri',
                method: 'POST',
                body: {
                    bookId,
                    resourceId,
                    manifest,
                    ...(jumpOffPoint && { jumpOffPoint }),
                    ...(analyticsUrl && { analyticsUrl }),
                },
            }),
        }),
    }),
});

export const { useOpenAriMutation } = openAriApi;
